import React from "react";
import pl from "../../assets/icons/pl.png";
import styled from "styled-components";
import { MdExpandMore } from "react-icons/md";

const PickerWrapper = styled.div`
  margin-left: 24px;
  margin-right: 40px;
  cursor: pointer;
`;

const Label = styled.label`
  margin: 0 8px;
`;

function LangPicker({}: ILangPicker) {
  return (
    <PickerWrapper>
      <img src={pl} />
      <Label>PL</Label>
      <MdExpandMore style={{ marginTop: "7px" }} />
    </PickerWrapper>
  );
}

export interface ILangPicker {}

export default LangPicker;
